import React from 'react';
import type { Select as Interface } from '../../design/components';

export const Select: React.FC<Interface> = ({
  name, description, state, placeholder, hidden, inline, readonly, disabled, required,
  error, options = [], clearable
}) => {
  const [value, setValue] = state || ['', () => {}];

  // Inline mode: render the selected option's label or value as text
  if (inline) {
    const selected = options.find(opt => opt.state?.[0] === value);
    return (
      <span style={{ display: hidden ? 'none' : undefined }}>
        {selected?.label || value || ''}
      </span>
    );
  }

  return (
    <div style={{ marginBottom: '1rem', display: hidden ? 'none' : undefined }}>
      <label htmlFor={name} style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>
        {name}
        {required && <span style={{ color: 'red' }}> *</span>}
      </label>
      <select
        id={name}
        name={name}
        value={value ?? ''}
        disabled={disabled || readonly}
        required={required}
        onChange={(e) => setValue(e.target.value)}
        style={{
          width: '100%',
          padding: '8px 12px',
          fontSize: '16px',
          border: error ? '1px solid red' : '1px solid #ccc',
          borderRadius: '4px',
          boxSizing: 'border-box' as const,
          backgroundColor: readonly ? '#f5f5f5' : undefined,
        }}
      >
        {clearable && <option value="">{placeholder || ''}</option>}
        {options.map(opt => {
          const optValue = opt.state?.[0] as string;
          return (
            <option key={optValue} value={optValue}>
              {opt.label || optValue}
            </option>
          );
        })}
      </select>
      {(error || description) && (
        <small style={{ color: error ? 'red' : '#666', display: 'block', marginTop: '4px' }}>
          {error || description}
        </small>
      )}
    </div>
  );
};
